import { defineMessages } from 'react-intl';

export const CategoryMessages = defineMessages({
  clearSelection: {
    id: 'search.filters.category.clearSelection',
    defaultMessage: 'Auswahl aufheben',
  },
  itemsQuantity: {
    id: 'search.filters.category-itemsQuantity',
    defaultMessage: 'Anzahl der Artikel: {count}',
  },
});
